import { apiSlice } from "./apiSlice";
import { ROLES } from "src/constants";

const apiEndpoints = {
    [ROLES.merchant]: "/v1/merchant-dashboard/login",
    [ROLES.shippingCompany]: "/v1/merchant-dashboard/login",
    [ROLES.admin]: "/admin-panel/login",
    merchant: "/merchant-dashboard/login",
    [ROLES.warehouseGuard]: "/warehouse_guard/login",
    driver: '/driver/login',
}

const getURLPath = (role) => {
    try {
        // const state = store.getState()
        // let profile = state.entities.profile.profile
        return apiEndpoints[role]
    } catch (error) {
        console.log("error")
        console.log(error)
    }
}

export const authApi = apiSlice.injectEndpoints({
    keepUnusedDataFor: 1,
    endpoints: builder => ({
        login: builder.mutation({
            query: ({ role, payload }) => ({
                url: getURLPath(role),
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        generalLogin: builder.mutation({
            query: (payload) => ({
                url: '/user/login',
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        registerAsMerchant: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/register`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        registerAsFreelanceDriver: builder.mutation({
            query: (payload) => ({
                url: `/driver/register`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        verifyPhone: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/verify-phone`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        changeMerchantRegistrationPhone: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/update-phone`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        sendZidIntegrate: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/zid-integrate`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        sendEmailToResetPassword: builder.mutation({
            query: (payload) => ({
                url: `/user/forget-password`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getDeliverySetting: builder.query({
            query: () => ({
                url: '/merchant-dashboard/delivery-setting',
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        resetPassword: builder.mutation({
            query: (payload) => ({
                url: `/user/reset-forgotten-password`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        emailExist: builder.query({
            query: (email) => ({
                url: `/user/email-existance?email=${email}`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getShortenUrl: builder.query({
            query: (refId) => ({
                url: `/url-shorten/${refId}`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getShortenUrlByOrderId: builder.query({
            query: (orderId) => ({
                url: `/url-shorten/order/${orderId}`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
    })
})

export const {
    useChangeMerchantRegistrationPhoneMutation,
    useVerifyPhoneMutation,
    useRegisterAsMerchantMutation,
    useRegisterAsFreelanceDriverMutation,
    useLoginMutation,
    useGeneralLoginMutation,
    useSendZidIntegrateMutation,
    useSendEmailToResetPasswordMutation,
    useGetDeliverySettingQuery,
    useResetPasswordMutation,
    useLazyEmailExistQuery,
    useGetShortenUrlQuery,
    useLazyGetShortenUrlQuery,
    useLazyGetShortenUrlByOrderIdQuery
} = authApi